import { render, staticRenderFns } from "./MyPagination.vue?vue&type=template&id=f4eed756&scoped=true"
import script from "./MyPagination.vue?vue&type=script&lang=js"
export * from "./MyPagination.vue?vue&type=script&lang=js"
import style0 from "./MyPagination.vue?vue&type=style&index=0&id=f4eed756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eed756",
  null
  
)

export default component.exports